import Vue from "vue";
import "./assets/css/c1-design.css";
import GnmNav from "./components/GnmNav.vue";
Vue.component('GnmNav', GnmNav);
import App from "./main/app.main/App";
import router from "./router";
import store from "./store";
import moment from "moment";
import "moment-timezone";
import VueStringFilter from "vue-string-filter";
import * as VueGoogleMaps from "vue2-google-maps";
import Geocoder from "@pderas/vue2-geocoder";
import VueNativeNotification from "vue-native-notification";
import VTooltip from "v-tooltip";
import VueSignaturePad from 'vue-signature-pad';

// Check that service workers are supported
if ("serviceWorker" in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js");
  });
}
Vue.use(VueSignaturePad);
Vue.use(VTooltip);
// Vue.directive('tooltip', VTooltip)

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDiaFjiwG5ApvqE3FHajEBm6HTXxWKWJEk",
    libraries: "places"
  }
});

Vue.use(Geocoder, {
  defaultCountryCode: null,
  defaultLanguage: null,
  defaultMode: "address",
  googleMapsApiKey: "AIzaSyDiaFjiwG5ApvqE3FHajEBm6HTXxWKWJEk"
});

Vue.filter("shortDate", function(value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("DD/MM/YYYY");
});

Vue.filter("shortTime", function(value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("HH:mm");
});

Vue.filter("mediumDateTime", function(value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("MMM Do HH:mm");
});

Vue.use(VueStringFilter);
Vue.config.productionTip = false;
Vue.config.silent = true;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
